import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';

import { BACKEND_URL, API } from '../config';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const tok = localStorage.getItem('tp_token');
    const u = localStorage.getItem('tp_user');
    const a = localStorage.getItem('tp_admin');
    if (tok && u) setUser(JSON.parse(u));
    if (a) setAdmin(JSON.parse(a));
    setLoading(false);
  }, []);

  const requestOtp = async (mobile) => {
    const r = await axios.post(`${API}/auth/request-otp`, { mobile });
    return r.data;
  };

  const verifyOtp = async (mobile, otp) => {
    const r = await axios.post(`${API}/auth/verify-otp`, { mobile, otp });
    localStorage.setItem('tp_token', r.data.token);
    localStorage.setItem('tp_user', JSON.stringify(r.data.user));
    setUser(r.data.user);
    return r.data;
  };

  const adminLogin = async (username, password) => {
    const r = await axios.post(`${API}/admin/login`, { username, password });
    localStorage.setItem('tp_admin_token', r.data.token);
    localStorage.setItem('tp_admin', JSON.stringify(r.data.admin));
    setAdmin(r.data.admin);
    return r.data;
  };

  const logout = () => {
    localStorage.removeItem('tp_token');
    localStorage.removeItem('tp_user');
    setUser(null);
  };

  const adminLogout = () => {
    localStorage.removeItem('tp_admin_token');
    localStorage.removeItem('tp_admin');
    setAdmin(null);
  };

  return (
    <AuthContext.Provider value={{ user, admin, loading, requestOtp, verifyOtp, adminLogin, logout, adminLogout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
